import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { SensorTypeEnum } from '@zaoblako/shared/modules/traffic/enums/sensor.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link SensorTypeEnum} enumeration values */
export const SensorTypeEnumI18n: EnumI18nInterface<SensorTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [SensorTypeEnum.INOUT]: 'Вход-выход',
    [SensorTypeEnum.PASS]: 'Прошли мимо',
  },
  [I18nLocalesEnum.EN_US]: {
    [SensorTypeEnum.INOUT]: 'In out',
    [SensorTypeEnum.PASS]: 'Passed',
  },
};
